export const embedLanguageInUrl = (link, language, excludedLanguages = []) => {
  if (!link) return;
  if (language === "en" || excludedLanguages.includes(language)) return link;
  const linkArray = link.split("/");
  linkArray.splice(3, 0, language);
  return linkArray.join("/");
};
